import { Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContractorApiService } from '../api/contractor-api.service';
import { ContractorListDto } from '../../models/contractors/contractor-list-dto';
import { ContractorListFilter } from '../../models/contractors/contractor-list-filter';

@Injectable({
  providedIn: 'root'
})
export class ContractorListService {
  private dataSubject = new BehaviorSubject<ContractorListDto[] | null>(null);
  data$ = this.dataSubject;

  constructor(private contractorApiService: ContractorApiService) { }


  @Output() filterChange = new BehaviorSubject<ContractorListFilter>({
    search: [],
    cities: [],
    statuses: []
  });

  loadContractors() {
    this.contractorApiService.getContractorList().subscribe(data => {
      this.dataSubject.next(data)
    });
  }

  applyFilter(filterValues: ContractorListFilter | undefined) {
    filterValues ? this.filterChange.next(filterValues) : console.log('no filter found');
  }
}
